module.exports = __webpack_public_path__ + "img/landlord-to-tenant.a8f767a4.jpg";